module.exports = new __parcel__URL__("kitten2.05362e79.png").toString();